
import gql from 'graphql-tag'

// """查询学校(经销商)"""
export const findSchool = gql`
  query($schoolId: Int!) {
    findSchool(
      schoolId: $schoolId,
    ) {
      area {
        cityCode
        createdAt
        id
        ing
        lat
        levelType
        managers {
          createdBy {
            id
            username
          }
          modifiedBy {
            id
            username
          }
        }
        mergerName
        name
        parentId
        pinyin
        shortName
        updatedAt
        zipCode
      }
      dealers {
        id
        realname
        storeName
        storePhone
        status
        user {
          phone
        }
      }
      areaId
      createdAt
      id
      managers {
        createdBy {
          id
          username
        }
        modifiedBy {
          id
          username
        }
      }
      name
      status
      updatedAt
    }
  }
`

// """查询学校列表(经销商)"""

export const findSchools = gql`
  query($order: [SchoolsFindOrder!], $paging: PagingQuery, $where: SchoolsFindFilter) {
    findSchools(
      order: $order,
      paging: $paging,
      where: $where,
    ) {
      schools {
        area {
          cityCode
          createdAt
          id
          ing
          lat
          levelType
          managers {
            createdBy {
              id
              username
            }
            modifiedBy {
              id
              username
            }
          }
          mergerName
          name
          parentId
          pinyin
          shortName
          updatedAt
          zipCode
        }
        dealers {
          id
          realname
          storeName
          storePhone
          status
          user {
            phone
          }
        }
        areaId
        createdAt
        id
        managers {
          createdBy {
            id
            username
          }
          modifiedBy {
            id
            username
          }
        }
        name
        status
        updatedAt
      }
      paging {
        currentOffset
        take
        totalCount
      }   
    }
  }
`

// """查询下级地区"""
export const queryAreas = gql`
  query($parentId: Int) {
    queryAreas(
      parentId: $parentId,
    ) {
      cityCode
      createdAt
      id
      ing
      lat
      levelType
      managers {
        createdBy {
          id
          username
        }
        modifiedBy {
          id
          username
        }
      }
      mergerName
      name
      parentId
      pinyin
      shortName
      updatedAt
      zipCode
    }
  }
`

// """查询地区列表"""
export const findAreas = gql`
  query($order: [AreasFindOrder!], $paging: PagingQuery, $where: AreasFindFilter) {
    findAreas(
      order: $order,
      paging: $paging,
      where: $where,
    ) {
      areas {
        cityCode
        createdAt
        id
        ing
        lat
        levelType
        managers {
          createdBy {
            id
            username
          }
          modifiedBy {
            id
            username
          }
        }
        mergerName
        name
        parentId
        pinyin
        shortName
        updatedAt
        zipCode
      }
      paging {
        currentOffset
        take
        totalCount
      }
    }
  }
`

// 删除学校
export const deleteSchool = gql`
  mutation($schoolId: Int!) {
    deleteSchool(
      schoolId: $schoolId,
    ) 
  }
`

export const exportSchoolsList = gql`
  query($order: [SchoolsFindOrder!],$where: SchoolsFindFilter) {
    exportSchoolsList(
      order: $order,
      where: $where
    ) {
      fileName
      contentB64
    }
  }
`
